@if(authService.isAuth()){
<nz-layout class="container-layout">

    <nz-sider class="page-sider" [nzCollapsedWidth]="60" [nzCollapsed]="api.menuCollapse" [nzTrigger]="null"
        nzCollapsible [nzWidth]="275">
        <div class="cursor-pointer mb-3" [ngClass]="api.menuCollapse ? 'logo-icon' : 'logo' ">
            <img [src]="api.menuCollapse ? 'wwof-icon.png' : 'logo.png'" />
        </div>
        <ul class="menu-list" nz-menu nzMode="inline" nzTheme="dark" [nzInlineCollapsed]="api.menuCollapse">
            @if(api.mainMenuList && api.mainMenuList.menuList.length > 0){
            @for(list of api.mainMenuList.menuList;track list.id){

            <li nz-submenu #subMenu [nzOpen]="list.open" [attr.data-key]="list.name"
                [class.no-arrow]="!list.subMenuList?.length"
                [ngClass]="activeLiUrl?.includes(list.routes) && !list.subMenuList?.length ? 'li-selected' : 'li-unselected'"
                [title]="list.name" (click)="listNavigate(list)">
                <span title class="custom-submenu-title">
                    <img [src]="list.icon" class="anticon custom-menu-img" alt="" />
                    <span class="custom-menu-text">{{ list.name }}</span>
                </span>

                <ul>
                    @for(child of list.subMenuList; track child.id){
                    <li [routerLink]="child.route" [nzSelected]="activeUrl.includes(child.key) ? true : false"
                        [ngClass]="activeLiUrl ? 'li-unselected' : ''" [title]="child.name" nz-menu-item
                        (click)="activeLiUrl=''">
                        {{ child.name }}</li>
                    }
                </ul>
            </li>


            }
            }
        </ul>
        <div class="bottom-menu">

            <ul nz-menu nztheme="dark" nzMode="inline">
                <li [nz-tooltip]="!api.menuCollapse ? null :userToolTip" nz-menu-item
                    class="border-bottom border-top username-li">
                    <span title>

                        <span nz-icon nzType="user"></span>
                        @if(!api.menuCollapse){
                        <ng-container>
                            <span>{{authService.name}}</span>

                            <p class="fs-11">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{authService.username}}</p>
                        </ng-container>
                        }
                        <ng-template #userToolTip>
                            {{authService.name}} <br />
                            &nbsp;&nbsp;&nbsp; {{authService.username}}
                        </ng-template>
                    </span>


                </li>
                <li [nz-tooltip]="!api.menuCollapse ? null :'Logout'" nz-menu-item (click)="authService.logout('type2')"
                    ariaCurrentWhenActive="page">
                    <span title>
                       <img src="logout.svg" class="anticon custom-menu-img"
                            alt="" />
                        @if(!api.menuCollapse){
                        <ng-container>
                            <span>Logout</span>
                        </ng-container>}

                    </span>
                </li>
                <li nz-menu-item [nz-tooltip]="!api.menuCollapse ? null :'Expand'"
                    (click)="api.menuCollapse = ! api.menuCollapse">
                    <span title>
                        <!-- <span nz-icon [nzType]="api.menuCollapse ? 'menu-unfold' : 'menu-fold'"></span> -->
                        <img [src]="api.menuCollapse ? 'menu-unfold.svg' : 'menu-fold.svg'" class="anticon custom-menu-img"
                            alt="" />
                        @if(!api.menuCollapse){
                        <ng-container>
                            <span>Collapse</span>
                        </ng-container>
                        }
                    </span>
                </li>

            </ul>
        </div>
    </nz-sider>
    <nz-layout [ngClass]="zoomLevel >= 110 ? 'content-layout':''" style="width: 100%;">
        <nz-header>
            <div class="header-left col-md-10">
                <div class="collapse-image">
                    <img [src]="api.menuCollapse ? 'sidemenu-switcher-open.png' : 'sidemenu-switcher-close.png' "
                        (click)="api.menuCollapse = ! api.menuCollapse" />
                </div>
            </div>
        </nz-header>
        <nz-content>
            <router-outlet></router-outlet>
        </nz-content>
    </nz-layout>
</nz-layout>
}
@else {
<router-outlet></router-outlet>
}